module.exports = __webpack_public_path__ + "img/private-napolimania-pizza-2.83b5f6a2.jpg";